import React from "react";

export const domainUrl = "https://adcumulate.com";
export const productionPath = "/production";
export const spacerText = (<span>{"  •  "}</span>);
